import PropTypes from "prop-types"
import React, { useEffect, useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import dictionary from "../../config/dictionary"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
//import Charts
import StackedColumnChart from "./StackedColumnChart"

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import PendingDocuments from "./PendingDocuments"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SessionConfig from "../../config/session_config"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import Messages from "./Messages"

const Dashboard = props => {
  const { t } = useTranslation()
  const ref = useRef()

  const { ordersCount, current } = useSelector(state => ({
    ordersCount: state.OrdersCount.billsCount,
    current: state.Dashboard.user,
  }))

  const [reports, setReports] = useState([])

  useEffect(() => {
    if (ordersCount.length > 0) {
      buildData()
    }
  }, [ordersCount])
  useEffect(() => {
    document.getElementById("body").className = "fondo4"
  }, [])
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(onGetChartsData("yearly"))
  }, [dispatch])

  const buildData = () => {
    let orderCount = 0
    let pendingCount = 0
    ordersCount.forEach(e => {
      if (e.statePayCode !== dictionary.configApp.type.orderPayed) {
        pendingCount += e.count
      }
      orderCount += e.count
    });
    const rest = orderCount - pendingCount

    const orders = {
      title: t("dashboard:bills"),
      iconClass: "bx-copy-alt",
      description: orderCount.toLocaleString('en'),
      css: ""
    }
    const orderPending = {
      title: t("dashboard:billPending"),
      iconClass: "bx-archive-in",
      description: pendingCount.toLocaleString('en'),
      css: "text-danger"
    }
    const paymentHistory = {
      title: t("dashboard:billPayed"),
      iconClass: "bx-box",
      description: (rest < 0 ? 0 : rest).toLocaleString('en'),
      css: ""
    }
    const dataR = [orders, paymentHistory, orderPending]
    setReports(dataR)
  }
  //meta title
  document.title = t("dashboard:title") + " | " + t("global:title")

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("global:title")}
            breadcrumbItem={props.t("dashboard:title")}
          />

          <Row>
            <Col xl="4">
              <WelcomeComp />
              {current?.supplier && <PendingDocuments />}
            </Col>
            <Col xl="8">
              <Row>
                {/* Reports Render */}
                {reports.map((report, key) => (
                  <Col md="4" key={"_col_" + key} >
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Link to="/account_status/" >
                          <div className="d-flex" >
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className={"mb-0 " + report.css}>{report.description}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                ></i>
                              </span>
                            </div>
                          </div>
                        </Link>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
              <Row>
                <Col>
                  <Messages />
                </Col>
              </Row>
              <Card>
                <CardBody>
                  <div className="d-sm-flex flex-wrap">
                    <h4 className="card-title mb-4">{t("dashboard:bills")}</h4>
                  </div>
                  <StackedColumnChart />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
